var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUgx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2757_5841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: -1,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2757_5841)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#FECA00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2757_5841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2757_5841)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 3.83333,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.6665,
    width: 23,
    height: 3.83333,
    fill: "#D74800"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11.5,
    width: 23,
    height: 3.83333,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 19.1665,
    width: 23,
    height: 3.83333,
    fill: "#D74800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 17.25C13.8817 17.25 15.8125 14.6756 15.8125 11.5C15.8125 8.32436 13.8817 5.75 11.5 5.75C9.11827 5.75 7.1875 8.32436 7.1875 11.5C7.1875 14.6756 9.11827 17.25 11.5 17.25Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83221 7.98167L9.07179 8.31436L9.83221 8.40116C9.83221 8.40116 9.95515 8.80208 9.83221 9.11506C9.801 9.19451 9.7205 9.2963 9.61774 9.42623C9.31572 9.80812 8.82144 10.4331 8.82144 11.4485C8.82144 12.8094 10.7912 13.4265 10.7912 13.4265V14.073C10.7912 14.073 11.0198 14.2624 9.71543 14.2624C8.58423 14.2624 8.65498 14.8349 8.69371 15.1484C8.69964 15.1964 8.70482 15.2383 8.70482 15.2711C8.70482 15.5186 9.24852 15.0237 9.50302 14.5309C9.637 14.2715 10.198 14.2852 10.7738 14.3564C10.8193 14.362 11.2391 15.5478 10.8746 16.1603C10.7215 16.4177 10.1928 16.4512 9.86239 16.4721C9.69394 16.4828 9.57708 16.4902 9.58791 16.5224C9.59604 16.5465 9.69567 16.5386 9.84048 16.527C10.0212 16.5127 10.2723 16.4927 10.5038 16.5224C10.5389 16.5269 10.4027 16.6845 10.265 16.8439C10.1231 17.0081 9.97968 17.1741 10.0201 17.1766C10.0655 17.1795 10.3312 16.9833 10.5725 16.805C10.7721 16.6576 10.9552 16.5224 10.9831 16.5224C11.1652 16.5224 11.3296 16.5523 11.4738 16.5786C11.7149 16.6225 11.8995 16.6562 12.0157 16.5224C12.0515 16.4812 11.844 16.4149 11.6325 16.3473C11.4145 16.2777 11.1922 16.2067 11.2273 16.1603C11.4276 15.8952 11.3439 15.3396 11.278 14.9019C11.2484 14.7056 11.2224 14.533 11.2273 14.4211C11.2444 14.0236 11.5597 14.2321 11.8076 14.396C11.9161 14.4677 12.0117 14.5309 12.0636 14.5309C12.533 14.5309 11.9502 13.7394 11.6303 13.305C11.6023 13.2669 11.5763 13.2316 11.5532 13.1998C11.3905 12.9758 11.5046 13.0059 11.7625 13.0739C11.9593 13.1258 12.2399 13.1998 12.545 13.1998C13.2501 13.1998 13.7647 12.8944 13.586 12.0674C13.468 11.5218 12.8223 11.3362 12.1476 11.1422C11.7996 11.0422 11.444 10.9399 11.1491 10.785C10.4236 10.4037 10.4605 9.84775 10.4918 9.37768C10.4979 9.28625 10.5038 9.19808 10.5038 9.11506C10.5038 8.60522 11.1491 7.98167 11.1491 7.98167C11.1491 7.98167 10.8546 7.32373 10.3662 7.32373C9.87784 7.32373 9.83221 7.98167 9.83221 7.98167ZM11.1606 13.9692V13.4883C11.1606 13.4883 11.4622 13.4751 11.5679 13.8133C11.6737 14.1516 11.1606 13.9692 11.1606 13.9692Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39903 6.43198L10.1275 7.58384L10.5048 7.46553L10.3239 6.30273L9.39903 6.43198Z",
    fill: "#D74800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3448 6.15323L10.3918 7.88499L11.0138 7.6809L11.2787 6.5467L10.3448 6.15323Z",
    fill: "#FFD018"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75841 9.0458C9.89582 9.0458 10.0072 8.90099 10.0072 8.72236C10.0072 8.54373 9.89582 8.39893 9.75841 8.39893C9.621 8.39893 9.50961 8.54373 9.50961 8.72236C9.50961 8.90099 9.621 9.0458 9.75841 9.0458Z",
    fill: "#D74800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3393 6.47752L10.6151 7.63412L10.768 8.10895L11.5954 7.66946L11.3393 6.47752Z",
    fill: "#D74800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0228 15.2309C13.0228 15.2309 14.2967 14.4721 14.2967 13.4109C14.2967 12.3497 12.2282 11.1938 12.2282 11.1938C12.2282 11.1938 11.0114 11.5652 11.5598 12.0621C12.1083 12.559 12.8431 12.7499 12.8431 13.4109C12.8431 14.072 13.0444 14.7023 12.6363 14.7023C12.2282 14.7023 13.0228 15.2309 13.0228 15.2309Z",
    fill: "#D74800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1848 11C11.1848 11 10.7343 11.1055 10.7557 11.2031C10.8148 11.4729 11.4309 11.8242 11.6994 12.0675C12.2478 12.5644 12.7678 12.5085 13.1547 12.1852C13.5415 11.8618 11.1848 11 11.1848 11Z",
    fill: "#FFFDFF"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2757_5841)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2757_5841",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUgx);
export default __webpack_public_path__ + "static/media/UGX.c17e6590cde2a75bbaca3d8c40745256.svg";
export { ForwardRef as ReactComponent };